export default __webpack_public_path__ + "static/media/Car_Lora_Thumb_Genesis.247b0a67.jpg";